import React from 'react';
import { Z_FONDO_SIDEBAR } from './useSidebarResponsive';

/**
 * Fondo que cierra el sidebar en mobile.
 *
 * NO ES DECORATIVO, ES LA UNICA SALIDA: el <Sider> es `position:fixed; left:0`
 * con 200px de ancho, y el boton hamburguesa del Header esta en `x: 0..64`. En
 * un telefono, con el sidebar abierto, ese boton queda TAPADO. Sin este fondo
 * el usuario no tiene forma de cerrar el menu salvo navegando a otra pantalla.
 *
 * Se usa junto con `useSidebarResponsive`, que es de donde salen `visible`
 * (`esMobile && !collapsed`) y `onClick` (`cerrarSiEsMobile`).
 */
const FondoSidebarMobile = ({ visible, onClick }) => {
  if (!visible) return null;
  return (
    <div
      onClick={onClick}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.45)',
        zIndex: Z_FONDO_SIDEBAR,
      }}
    />
  );
};

export default FondoSidebarMobile;
